/*
 * Shop the Look — version autonome (portable)
 * Custom elements <shop-the-look> et <stl-hotspots>.
 * Aucune dépendance externe (ni theme.js, ni PhotoSwipe).
 * Au clic sur un hotspot, la carte produit intégrée s'affiche.
 */
(function () {
  'use strict';

  var DESIGN_MODE = window.Shopify && window.Shopify.designMode;

  if (!customElements.get('stl-hotspots')) {
    customElements.define(
      'stl-hotspots',
      class extends HTMLElement {
        constructor() {
          super();
          this.initialOpen = this.hasAttribute('data-stl-initial-open');
        }

        get items() {
          return Array.prototype.slice.call(this.querySelectorAll('[data-stl-hotspots-item]'));
        }
        get targets() {
          return Array.prototype.slice.call(this.querySelectorAll('[data-stl-hotspots-target]'));
        }
        get triggers() {
          return Array.prototype.slice.call(this.querySelectorAll('[data-stl-hotspots-trigger]'));
        }

        connectedCallback() {
          this.init();
          this.listen();
        }

        init() {
          // "block-selected" active le positionnement final de la carte (voir CSS)
          this.items.forEach((item) => item.classList.add('block-selected'));
          if (this.initialOpen) {
            var delay = DESIGN_MODE ? 300 : 500;
            setTimeout(() => this.select(0), delay);
          }
          this.focusables();
        }

        listen() {
          // Le point cliquable (le rond) ouvre/ferme la carte
          this.targets.forEach((target) => {
            target.addEventListener('click', (event) => {
              var index = this.targets.indexOf(event.currentTarget);
              this.select(index);
            });
          });

          // Le titre (bulle) relaie le clic vers le point correspondant
          this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
              var index = this.triggers.indexOf(event.currentTarget);
              if (this.targets[index]) this.targets[index].dispatchEvent(new Event('click'));
            });
          });

          this.addEventListener('keyup', (event) => this.onKeyup(event));
        }

        deselectAll() {
          this.items.forEach((item) => item.classList.remove('is-active'));
          this.focusables();
        }

        select(index) {
          this.items.forEach((item, i) => {
            // Toggle : re-cliquer sur un hotspot déjà ouvert le referme
            if (i === index) {
              var willOpen = !item.classList.contains('is-active');
              item.classList.toggle('is-active', willOpen);
              item.setAttribute('aria-current', willOpen ? 'true' : 'false');
            } else {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            }
          });
          this.focusables();
        }

        focusables() {
          this.items.forEach((item, i) => {
            var isActive = item.classList.contains('is-active');
            var tabindex = isActive ? '0' : '-1';
            item
              .querySelectorAll('.hotspot__content a, .hotspot__content button')
              .forEach((el) => el.setAttribute('tabindex', tabindex));
            if (this.targets[i]) this.targets[i].setAttribute('aria-expanded', String(isActive));
          });
        }

        onKeyup(event) {
          var isEscape = event.key === 'Escape' || event.keyCode === 27;
          if (!isEscape) return;
          this.deselectAll();
          var item = event.target.closest('[data-stl-hotspots-item]');
          if (item) {
            var target = item.querySelector('[data-stl-hotspots-target]');
            if (target) target.focus();
          }
        }
      }
    );
  }

  if (!customElements.get('shop-the-look')) {
    customElements.define(
      'shop-the-look',
      class extends HTMLElement {
        get hotspots() {
          return this.querySelector('stl-hotspots');
        }

        connectedCallback() {
          if (!this.hotspots) return;
          // Un clic en dehors d'un hotspot referme la carte ouverte
          this.addEventListener('click', (event) => {
            if (!event.target.closest('[data-stl-hotspots-item]')) {
              this.hotspots.deselectAll();
            }
          });
        }
      }
    );
  }

  // Support de l'éditeur de thème Shopify (sélection de blocs)
  if (DESIGN_MODE) {
    document.addEventListener('shopify:block:select', (event) => {
      var stl = event.target.closest('shop-the-look');
      if (!stl) return;
      var hotspots = stl.querySelector('stl-hotspots');
      var item = event.target.closest('[data-stl-hotspots-item]');
      if (hotspots && item) {
        var index = hotspots.items.indexOf(item);
        hotspots.items.forEach((el, i) => {
          el.classList.toggle('is-active', i === index);
          el.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        hotspots.focusables();
      }
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      var stl = event.target.closest('shop-the-look');
      if (!stl) return;
      var hotspots = stl.querySelector('stl-hotspots');
      if (hotspots) hotspots.deselectAll();
    });
  }
})();
